import i18next from "i18next";

import { createColumn } from "../../../../../../components/Table";

export const manageAlertsTableColumns = [
  createColumn({
    keyName: "measurementType",
    header: () => i18next.t("patientPage_columns_type"),
    cell: (info) => info.renderValue(),
    size: 250,
  }),
  createColumn({
    keyName: "trigger",
    header: () => i18next.t("patientPage_columns_trigger"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "timeFrame",
    header: () => i18next.t("patientPage_columns_time_frame"),
    cell: (info) => info.renderValue(),
    size: 140,
  }),
  createColumn({
    keyName: "hcpNotification",
    header: () => i18next.t("patientPage_columns_hcp_notification"),
    cell: (info) => info.renderValue(),
    size: 180,
  }),
  createColumn({
    keyName: "hcpMessage",
    header: () => i18next.t("patientPage_columns_hcp_message"),
    cell: (info) => info.renderValue(),
    size: 800,
  }),
  createColumn({
    keyName: "empty",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 10,
  }),
  createColumn({
    keyName: "created",
    header: () => i18next.t("patientPage_columns_created"),
    cell: (info) => info.renderValue(),
    size: 240,
  }),
  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 10,
  }),
];
